import NTopNBottom from '../../components/NTopNBottom'

import bannerImg from '../../assets/birthPhoto/banner.jpg'
import navColor from '../../assets/birthPhoto/nav/color.jpg'
import navBg from '../../assets/birthPhoto/nav/nav_bg.png'

import far1 from '../../assets/birthPhoto/nav/far1.png'
import far1_active from '../../assets/birthPhoto/nav/far1_active.png'
import far2 from '../../assets/birthPhoto/nav/far2.png'
import far2_active from '../../assets/birthPhoto/nav/far2_active.png'
import son1 from '../../assets/birthPhoto/nav/son1.png'
import son1_active from '../../assets/birthPhoto/nav/son1_active.png'
import son2 from '../../assets/birthPhoto/nav/son2.png'
import son2_active from '../../assets/birthPhoto/nav/son2_active.png'

import p1_1 from '../../assets/birthPhoto/ctn/1_1.jpg'
import p1_2 from '../../assets/birthPhoto/ctn/1_2.jpg'
import p2_1 from '../../assets/birthPhoto/ctn/2_1.jpg'
import p3_1 from '../../assets/birthPhoto/ctn/3_1.jpg'
import p3_2 from '../../assets/birthPhoto/ctn/3_2.jpg'
import p4_1 from '../../assets/birthPhoto/ctn/4_1.jpg'

const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'

import calcRemFn from '../calcRem'


// 需要手动修改proId
const top1_i1 = IS_PROD ? '94215' : '94215'
const top1_i2 = IS_PROD ? '94215' : '94215'
const top2_i1 = IS_PROD ? '94216' : '94216'
const top2_i2 = IS_PROD ? '94216' : '94216'

const navCss = {
  navWrap: {
    paddingTop: calcRemFn(44),
    minHeight: calcRemFn(192),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(148),
    backgroundImage: `url(${navBg})`,
  },
  topBtnLayout: {
    padding: `${calcRemFn(42)} ${calcRemFn(84)} 0 ${calcRemFn(114)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(75),
    height: calcRemFn(21.5),
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(24)} ${calcRemFn(100)} 0 ${calcRemFn(120)}`,
  },
  bottomBtnBaseCss: {
    width: calcRemFn(57),
    height: calcRemFn(17),
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active
      }
    ]
  }
}

const pictures = [
  {
    id: top1_i1,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1,
      p1_2
    ],
    name: '元气少年-单人'
  },
  {
    id: top2_i1,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p2_1,
    ],
    name: '元气少年-情侣'
  },
  {
    id: top1_i2,
    type: 'blue',
    ref: 'top1_i2',
    farName: 'top1',
    sonName: '_i2',
    son: [
      p3_1,
      p3_2,
    ],
    name: '生日C位-单人'
  },
  {
    id: top2_i2,
    type: 'blue',
    ref: 'top2_i2',
    farName: 'top2',
    sonName: '_i2',
    son: [
      p4_1,
    ],
    name: '生日C位-情侣'
  }
]

const topDiff = {
  firstSon: '_i1',
  top1_i1: 10,
  top1_i2: 20,
  top2_i1: 5,
  top2_i2: 16,
}

// const allPic = [far1, far1_active, far2, far2_active, son1, son1_active, son2, son2_active]

export default {
  title: '生日便利店',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
  // allPic
}
